export enum BoughtBeforeInSpcialsExperimentVariants {
	Control = 'control',
	V1FirstTwoResults = 'v1_first_two_results',
	V2AllResultsOnFirstPage = 'v2_all_results_on_first_page',
}
